<template>
  <div class="app-content--equal-padding py-8 px-16">
    <header class="mb-8">
      <v-card-title
        class="headline font-weight-bold mb-1 pa-0 letter-spacing-compact"
      >
        3. Confirm
      </v-card-title>
    </header>
    <v-row class="mt-0" v-if="request.project_id">
      <v-col class="py-0 mb-5">
        <v-card flat class="px-0 py-0">
          <v-list
            flat
            elevation="0"
            tile
            two-line
            dense
            max-height="400"
            class="overflow-auto border-none"
          >
            <v-list-item class="d-flex pa-0">
              <v-list-item-avatar size="44" class="ma-0" tile>
                <v-img
                  :src="getMedia(request.project)"
                  lazy-src="/placeholder.jpg"
                  aspect-ratio="1"
                  class="grey lighten-2"
                />
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title
                  class="ml-5 title font-weight-bold letter-spacing-normal"
                >
                  {{ request.project.name }}
                  <v-spacer />
                </v-list-item-title>
                <v-list-item-subtitle class="ml-5">
                  {{ request.project.manager.full_name }}
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>
      </v-col>
    </v-row>
    <v-row class="mt-0">
      <v-col class="py-0 mb-5">
        <v-card flat class="px-0 py-0">
          <v-list
            flat
            elevation="0"
            tile
            dense
            max-height="400"
            class="overflow-auto border-none"
          >
            <v-list-item class="d-flex pa-0">
              <v-list-item-content>
                <v-list-item-title>
                  <span class="subtitle-1 font-weight-bold">
                    Total Transfer
                  </span>
                </v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>
                <span class="subtitle-1 font-weight-bold">
                  $ {{ request.amount.currency(2) }}
                </span>
              </v-list-item-action>
            </v-list-item>
            <v-list-item class="d-flex pa-0">
              <v-list-item-content>
                <v-list-item-title>
                  <span class="subtitle-1">Remaining Balance</span>
                </v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>
                <span class="subtitle-1">
                  $ {{ (user.getBalance() - request.amount).currency(2) }}
                </span>
              </v-list-item-action>
            </v-list-item>
          </v-list>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import PayoutRequest from '@request/PayoutRequest';
import { mapState } from 'vuex';

export default {
  name: 'ConfirmPayout',
  props: {
    request: {
      type: PayoutRequest,
      required: true,
    },
  },
  data() {
    return {
      //
    };
  },
  computed: {
    ...mapState('auth', {
      user: 'user',
    }),
  },
  watch: {
    'request.percentage': {
      async handler(value) {
        await this.$nextTick();
        this.request.amount = this.getValueFromPercentage();
      },
    },
  },
  methods: {
    getValueFromPercentage(
      percentage = this.request.percentage,
      total = this.user.getBalance()
    ) {
      return ((percentage / 100) * total).currency(2);
    },
  },
  mounted() {
    this.request.amount = this.getValueFromPercentage();
  },
};
</script>

<style lang="scss" scoped></style>
